// src/js/subscriber.js
let Swal;

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('subscriber-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = document.getElementById('subscriber-email').value;

    try {
      if (!Swal) {
        const SwalModule = await import('sweetalert2');
        Swal = SwalModule.default;
      }

      const response = await fetch(subscriberAjax.ajaxurl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          action: 'register_subscriber',
          nonce: subscriberAjax.nonce,
          email: email,
        }),
      });

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          title: 'תודה על ההרשמה!',
          text: 'בקרוב תקבלו עדכונים מאיתנו.',
          icon: 'success',
          confirmButtonText: 'אישור',
        });
        form.reset();
      } else {
        throw new Error(data.data);
      }
    } catch (error) {
      Swal.fire({
        title: 'שגיאה!',
        text: error.message || 'אירעה שגיאה. אנא נסו שוב.',
        icon: 'error',
        confirmButtonText: 'סגור',
      });
    }
  });
});
